import { render, staticRenderFns } from "./ChooseIcon.vue?vue&type=template&id=a34af8a2&scoped=true"
import script from "./ChooseIcon.vue?vue&type=script&lang=js"
export * from "./ChooseIcon.vue?vue&type=script&lang=js"
import style0 from "./ChooseIcon.vue?vue&type=style&index=0&id=a34af8a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34af8a2",
  null
  
)

export default component.exports